import CheckCircleFill from '@/components/icons/CheckCircleFill';
import Cross from '@/components/icons/Cross';
import ErrorFill from '@/components/icons/ErrorFill';
import React from 'react';
import styles from './style.module.css';

export type InputProps = {
  label?: string;
  helperText?: string;
  errorMessage?: string;
  validated?: boolean;
  onChange?: (e: { target: { value: string } }) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input: React.FC<InputProps> = ({
  label = 'Label',
  placeholder = '',
  value,
  helperText = '',
  errorMessage,
  disabled = false,
  validated = false,
  readOnly = false,
  maxLength,
  onChange,
  onBlur,
}) => {
  function clearValue() {
    onChange && onChange({ target: { value: '' } });
  }
  function pickIcon() {
    if (errorMessage) {
      return <ErrorFill className={styles.icon}></ErrorFill>;
    }
    if (validated) {
      return <CheckCircleFill className={styles.icon}></CheckCircleFill>;
    }
    return (
      <div
        className={styles['icon-div']}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
      >
        <Cross
          onClick={(e) => {
            e.preventDefault();
            clearValue();
          }}
          className={styles['focus-icon']}
        ></Cross>
      </div>
    );
  }

  function pickStyle() {
    if (disabled) {
      return styles.disabled;
    }
    if (readOnly) {
      return styles['read-only'];
    }
    if (errorMessage) {
      return styles['error'];
    }
    if (validated) {
      return styles['validated'];
    }
    return '';
  }

  return (
    <div
      className={`gap-xs flex-column ${styles['input-block']}  ${
        disabled && styles['disabled']
      }`}
    >
      <div className={`gap-xs flex-column`}>
        <p>{label}</p>
        <div
          className={`flex-row gap-s ${
            styles['input-container']
          } ${pickStyle()}`}
        >
          <input
            maxLength={maxLength}
            onBlur={onBlur}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={placeholder}
            value={value}
            className={styles['input-field']}
            onChange={onChange}
          />
          {pickIcon()}
        </div>
      </div>
      {(helperText || errorMessage) && (
        <p className={`s ${errorMessage && styles['error-text']}`}>
          {errorMessage ? errorMessage : helperText}
        </p>
      )}
    </div>
  );
};

export default Input;
